import { LogDetail } from "./LogView";
import * as TestHook from "../sdServices/test-hook-service/test-hook-service";

export interface LogDetailWithTime extends LogDetail {
  timeStamp: Date;
}

export class InformativeAlertService {
  public standardInformativeAlertInUse: boolean = undefined;
  public logItems: LogDetailWithTime[] = [];
  public statesWithInformativeAlertControl: string[] = [];

  // @ngInject
  constructor(private $rootScope: ng.IRootScopeService, private testHookService: TestHook.TestHookService) {
    $rootScope.$on(TestHook.dismissTransientViews, () => {
      this.clearAllLogs();
    });
  }

  public getTopPriorityitem(): LogDetailWithTime[] {
    let ret: LogDetailWithTime[] = [];
    if (this.logItems.length > 0) {
      ret.push(this.logItems[0]);
    }
    return ret;
  }

  private sortLogItems() {
    let alertTypePriorityValue = (logItem: LogDetailWithTime) => {
      let alertTypePriorityValue = 0;
      switch (logItem.alertType) {
        case "Warning":
          alertTypePriorityValue++;
        case "Error":
          alertTypePriorityValue++;
        case "Information":
          alertTypePriorityValue++;
      }
      return alertTypePriorityValue;
    };
    this.logItems.sort((a: LogDetailWithTime, b: LogDetailWithTime) => {
      if (a.alertType !== b.alertType) {
        return alertTypePriorityValue(b) - alertTypePriorityValue(a);
      } else {
        return b.timeStamp.getTime() - a.timeStamp.getTime();
      }
    });
  }

  private clearAllLogs() {
    this.$rootScope.$applyAsync(() => {
      this.logItems.length = 0;
    });
  }

  public pushLog(logDetail: LogDetail) {
    if (!this.testHookService.shouldTransientViewsBeShown()) {
      console.info("Informative alert service: push log was suppressed by test hooks.");
      return;
    }

    this.$rootScope.$applyAsync(() => {
      let currentLogItem = <LogDetailWithTime>logDetail;
      let hasItemBeenShownAlready = this.logItems
        ? !!this.logItems.find((logItem) => logItem.uId == logDetail.uId)
        : false;
      if (this.logItems && this.logItems.length < 5 && !hasItemBeenShownAlready) {
        if (currentLogItem && (currentLogItem.displayText || currentLogItem.title)) {
          let closeCallback = () => {
            this.closeLog(currentLogItem);
          };
          currentLogItem.onClose = closeCallback.bind(this);
          currentLogItem.timeStamp = new Date();
          this.logItems.push(currentLogItem);
          this.sortLogItems();
        }
      }
    });
  }

  public isUsingGlobalHeader(currentState: any) {
    while (currentState && currentState.self.name) {
      let currentViews = currentState.self.views;
      if (currentViews && currentViews.hasOwnProperty("globalHeader") && currentViews.globalHeader) {
        return (this.standardInformativeAlertInUse = true);
      }
      currentState = currentState.parent;
    }
    return (this.standardInformativeAlertInUse = false);
  }

  public closeLog(logItemToRemove: LogDetail) {
    this.$rootScope.$applyAsync(() => {
      this.logItems = this.logItems.filter((logItem) => logItem != logItemToRemove);
    });
  }

  public closeLogByUId(uId: string) {
    this.$rootScope.$applyAsync(() => {
      this.logItems = this.logItems.filter((logItem) => logItem.uId != uId);
    });
  }
}
